function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.648 0.300049C15.9735 0.300049 17.048 1.37457 17.048 2.70005L17.048 24.3C17.048 25.6255 15.9735 26.7 14.648 26.7C13.3226 26.7 12.248 25.6255 12.248 24.3L12.248 2.70005C12.248 1.37457 13.3226 0.300049 14.648 0.300049ZM1.65412 7.00299C2.59137 6.06573 4.11097 6.06573 5.04823 7.00299L8.64823 10.603C10.2482 12.203 10.2482 14.7971 8.64823 16.3971L5.04823 19.9971C4.11097 20.9344 2.59138 20.9344 1.65412 19.9971C0.71686 19.0598 0.716859 17.5403 1.65412 16.603L4.75706 13.5L1.65412 10.3971C0.716857 9.45985 0.716857 7.94025 1.65412 7.00299Z",
  fill: "white"
});

function SvgArrowRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 27,
    viewBox: "0 0 18 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.921b98f0.svg";
export { ForwardRef as ReactComponent };